// extracted by mini-css-extract-plugin
export default {"Navigation":"EryEuVsEgw2ZJFHaJJRV","Inner":"fQuRBbsLCF6OdJuNHrkI","Variant--rounded":"RcJTg4nVmLyDpIuVK0le","Variant--shadowed":"TbdeGLEyxRERDCfjeJI8"};